// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"o8-z"};